import React from 'react';
import { connect } from 'react-redux';

import { PageContent } from '@zillow/constellation';
import { parseQueryString } from '@zg-rentals/string-utils';

import { AppSelectors } from '../../selectors';
import UserActions from '../../actions/UserActions';
import stringHelper from '../../utils/stringHelper';
import MarkAsSpam from './MarkAsSpam';
import ContactActions from './ContactActions';

import { StyledInquiryContact } from './StyledComponents';
import { logError } from '@zg-rentals/log-error';

class InquiryContact extends React.Component {
  constructor(props) {
    super(props);

    this.executeAction = this.executeAction.bind(this);
    this.saveIntention = this.saveIntention.bind(this);
    this.reportSpam = this.reportSpam.bind(this);
    this.setIntention = this.setIntention.bind(this);
    const params = parseQueryString(props.queryString);

    const { intentionType, inquiryId, controlHash, landlordBrand, renterBrand, name, phone, date } = params;

    if (!inquiryId || !controlHash) {
      logError({
        error: new Error(`Inquiry-Contact called with no inquiryId or controlHash urlParams:${props.queryString}`),
        errorType: 'InquiryContactError',
        context: 'InquiryContact.constructor',
      });
    }

    this.state = {
      intentionType,
      inquiryId,
      controlHash,
      landlordBrand,
      renterBrand,
      name: stringHelper.sanitizeReactInput(name),
      phone: stringHelper.sanitizeReactInput(phone),
      date: stringHelper.sanitizeReactInput(date),
    };
  }

  executeAction(intentionType, sendIntention = true) {
    const { phone } = this.state;

    if (intentionType === 'call') {
      if (sendIntention) {
        this.saveIntention(intentionType);
      }
      location.href = `tel:${phone}`;
    } else if (intentionType === 'sms') {
      if (sendIntention) {
        this.saveIntention(intentionType);
      }
      location.href = `sms:${phone}`;
    }

    this.setIntention(intentionType);
  }

  saveIntention(intentionType) {
    const { dispatch } = this.props;

    dispatch(
      UserActions.insertAction({
        intentionType,
        inquiryId: this.state.inquiryId,
        controlHash: this.state.controlHash,
        landlordBrand: this.state.landlordBrand,
        renterBrand: this.state.renterBrand,
      }),
    );
  }

  reportSpam() {
    const { dispatch, email } = this.props;
    const { inquiryId, controlHash } = this.state;

    dispatch(
      UserActions.reportSpam({
        inquiryId,
        controlHash,
        reporterEmail: email,
        comment: '',
      }),
    );
  }

  setIntention(intention) {
    this.setState({ intentionType: intention });

    // when choosing spam option in 'im not interested'
    if (intention === 'reportInquiryAsSpam') {
      this.saveIntention(intention);
    }
  }

  renderIntention(type) {
    const { isScreenDesktop } = this.props;
    const { intentionType, name, phone, date } = this.state;

    switch (type) {
      case 'call':
      case 'sms':
        return (
          <ContactActions
            onExecuteAction={this.executeAction}
            intentionType={intentionType}
            name={name}
            phone={phone}
            isMobile={!isScreenDesktop}
          />
        );
      case 'reportInquiryAsSpam':
        return <MarkAsSpam reportSpam={this.reportSpam} date={date} name={name} />;
      default:
        return <div />;
    }
  }

  render() {
    const { intentionType } = this.state;

    return (
      <StyledInquiryContact>
        <PageContent>{this.renderIntention(intentionType)}</PageContent>
      </StyledInquiryContact>
    );
  }
}

const mapStateToProps = (state) => ({
  email: state.user.email,
  isScreenDesktop: AppSelectors.makeIsScreenDesktop(state),
  queryString: state.router.location.search,
});

export default connect(mapStateToProps)(InquiryContact);
